'use client';
import React from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const services = [
{ name: 'AC Installation', desc: 'New system setup with professional sizing and ductwork.' },
{ name: 'AC Repair', desc: 'Fast diagnosis and repair for all makes and models.' },
{ name: 'Heating Systems', desc: 'Furnace and heat pump tune-ups, repairs, and replacements.' },
{ name: 'Preventive Maintenance', desc: 'Seasonal check-ups to keep your system running efficiently.' },
{ name: 'Emergency Service', desc: '24/7 emergency dispatch — we arrive same day.' },
{ name: 'Air Quality', desc: 'Filter replacements, duct cleaning, and air purifier installs.' }];


const PhoneIcon = () =>
<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
  </svg>;


export default function HVACPage() {
  return (
    <div>
      <Navbar />
      <main className="bg-paper min-h-screen">
        {/* Hero */}
        <section className="relative pt-36 pb-20 px-4 md:px-6 overflow-hidden">
          <div className="max-w-6xl mx-auto">
            <Link
              className="inline-flex items-center gap-2 text-ink-muted text-sm font-semibold mb-8 hover:text-ink transition-colors"
              href="/homepage">
              
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
                <path d="M19 12H5M5 12l7-7M5 12l7 7" />
              </svg>
              Back to Home
            </Link>
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <span className="inline-block bg-ink text-paper text-[10px] font-bold uppercase tracking-[0.22em] px-3 py-1.5 rounded-full mb-6">
                  24/7 Emergency
                </span>
                <h1
                  className="font-sans font-extrabold leading-none text-ink mb-6"
                  style={{ fontSize: 'clamp(2.8rem, 7vw, 5.5rem)', letterSpacing: '-0.04em' }}>
                  
                  HVAC<br />
                  <span className="font-serif italic font-normal text-ink-muted">Repair</span>
                </h1>
                <p className="text-ink-muted text-lg leading-relaxed mb-8 max-w-md">
                  Stay cool in summer, warm in winter. Our licensed HVAC technicians handle everything from emergency repairs to full system installations &mdash; same day.
                </p>
                <Link
                  href="tel:+13213614842"
                  className="inline-flex items-center gap-3 bg-ink text-paper px-8 py-4 rounded-full text-base font-bold hover:bg-ink/80 transition-all duration-300 hover:scale-105 active:scale-95">
                  
                  <PhoneIcon />
                  Call HVAC Specialist
                </Link>
              </div>
              <div className="relative rounded-3xl overflow-hidden" style={{ height: '420px' }}>
                <img
                  alt="HVAC technician servicing air conditioning unit on rooftop, bright sky"
                  loading="lazy"
                  style={{ position: 'absolute', height: '100%', width: '100%', left: 0, top: 0, right: 0, bottom: 0, objectFit: 'cover' }}
                  src="https://images.unsplash.com/photo-1532316191261-35afb35c7346" />
                
              </div>
            </div>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-20 px-4 md:px-6 bg-paper-warm">
          <div className="max-w-6xl mx-auto">
            <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-ink-faint mb-4">What We Do</p>
            <h2
              className="font-sans font-extrabold text-ink mb-12"
              style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', letterSpacing: '-0.03em' }}>
              
              Full-Spectrum HVAC Services
            </h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {services?.map((s) =>
              <div key={s?.name} className="bg-paper rounded-2xl p-6 border border-[rgba(13,13,13,0.06)]">
                  <h3 className="font-bold text-ink text-lg mb-2">{s?.name}</h3>
                  <p className="text-ink-muted text-sm leading-relaxed">{s?.desc}</p>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 px-4 md:px-6 bg-ink">
          <div className="max-w-3xl mx-auto text-center">
            <h2
              className="font-sans font-extrabold text-paper leading-none mb-6"
              style={{ fontSize: 'clamp(2rem, 5vw, 4rem)', letterSpacing: '-0.04em' }}>
              
              Ready to Book?
            </h2>
            <p className="text-paper/60 text-lg mb-10">
              Call our HVAC specialist directly. No hold music, no forms &mdash; just fast service.
            </p>
            <Link
              href="tel:+13213614842"
              className="inline-flex items-center gap-3 bg-paper text-ink px-10 py-5 rounded-full text-base font-bold hover:bg-paper-warm transition-all duration-300 hover:scale-105 active:scale-95">
              
              <PhoneIcon />
              Call Now
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>);

}